import React, {useContext} from 'react';

import styles from './ComponentHomePageMainServices.scss';
import whiteBox from '../../common/scss/WhiteBox.scss';

import shopIMG from '../../../img/Menu_icons/04_Menu_icon_Shopiko.svg';
import builderIMG from '../../../img/Menu_icons/05_Menu_icon_SiteBuilder.svg';
import certIMG from '../../../img/Menu_icons/06_Menu_icon_SSL.svg';
import mvpsIMG from '../../../img/Menu_icons/07_Menu_icon_ManagedVPS.svg';
import vpsIMG from '../../../img/Menu_icons/08_Menu_icon_VPS.svg';
import domainsIMG from '../../../img/Menu_icons/03_Menu_icon_Domains.svg';
import wpHostingIMG from '../../../img/Menu_icons/02_Menu_icon_WP.svg';
import sharedIMG from '../../../img/Menu_icons/01_Menu_icon_Hosting.svg';
import wpAIIMG from '../../../img/Menu_icons/WP_AI.svg';

import Price from '../../common/primitives/Price';
import {ContextServicePrice, ContextServicePriceProvider} from '../../context/ContextServicePriceProvider';
import RenderIf from '../../common/primitives/RenderIf/RenderIf';
import {__t} from '../../common/lang/text-resource';

const ServiceBox = ({title, description, price, currency, priceAdditional, currencyAdditional, link, img, isNew, isYearly}) => {
	const navigateToPage = () => window.location = link;

	let termSeparator = currency === 'BGN' ? '/' : ' ';

	return (
	  <div onClick={navigateToPage} className={`${styles.serviceBox} ${whiteBox.container} ${whiteBox.paddingNone}`}>

		  <div className={styles.header}>
			  <img src={img} alt={title}/>
			  <RenderIf condition={isNew === true}>
				  <div className={styles.newService}>
					  {__t('нова услуга')}
				  </div>
			  </RenderIf>
		  </div>

		  <div>
			  <a href={link}>
				  <span>{title}</span>
			  </a>
		  </div>

		  <p>
			  {description}
		  </p>
		  <div className={styles.priceContainer}>
			  <div>
				  {__t('Цени от')}
			  </div>
			  <div>
				  <Price currency={currency} value={price} includeDotAfterLV={false}
						 valueClass={styles.price}/>
				  {SHVO.showEuroPrices && <>
					  &nbsp;/&nbsp;
					  <Price currency={currencyAdditional} value={priceAdditional} includeDotAfterLV={false}
											  valueClass={styles.price}/>
				  </>}
				  &nbsp; {isYearly ? __t('год') : __t('мес')}
			  </div>
		  </div>

	  </div>

	)
}
const ComponentHomePageMainServices = () => {

	const lang = SHVO.pageLang ?? 'bg';

	/** @type {ContextServicePriceProvider} */
	const context = useContext(ContextServicePrice);
	const shopPrice = context.getVOForIdAndTerm('plan_gomba_shop_01', 12);
	const shopPriceSupport = context.getVOForIdAndTerm('shopiko_support_01', 12);
	const builderPrice = context.getVOForIdAndTerm('skreat_01', 12);
	const certPrice = context.getVOForIdAndTerm('ssl_goget_01', 12);
	const hostingPrice = context.getVOForIdAndTerm('plan_01', 12);
	const mvpsPrice = context.getVOForIdAndTerm('vps_m_011', 12);
	const vpsPrice = context.getVOForIdAndTerm('vps_vp_01', 12);
	const ssPrice = context.getVOForIdAndTerm('plan_01', 12);
	const sitePrice = context.getVOForIdAndTerm('site', 12);
	const wpaiPrice = context.getVOForIdAndTerm('plan_wpai_01', 12);

	return (
	  <section className={styles.container} id="JS_HomePage_MainServices">
		  {lang === 'en' && <ServiceBox
			title={__t("Онлайн магазин")}
			description={__t('бърз-и-лесен-старт-на-онлайн-магазин-без-инвестиц1e1330')}
			price={parseFloat(parseFloat(shopPrice.monthlyPriceNew) + parseFloat(shopPriceSupport.monthlyPriceNew)).toFixed(2)}
			currency={shopPrice.currency}
			priceAdditional={parseFloat(parseFloat(shopPrice.monthlyPriceNewEUR) + parseFloat(shopPriceSupport.monthlyPriceNewEUR)).toFixed(2)}
			currencyAdditional={shopPrice.currencyEUR}
			link="/web-hosting-compare-shop-plans.php"
			img={shopIMG}/>}
		  {lang === 'bg' && <ServiceBox
			title={__t("Споделен хостинг")}
			description={__t('предпочитаният-хостинг-от-над-200-хил-уебсайта-ин838fd1')}
			price={hostingPrice.monthlyPriceNew}
			currency={hostingPrice.currency}
			priceAdditional={hostingPrice.monthlyPriceNewEUR}
			currencyAdditional={hostingPrice.currencyEUR}
			link="/web-hosting-compare-hosting-plans.php"
			img={sharedIMG}/>}
		  {lang === 'en' && <ServiceBox
			title={__t("Domains")}
			description={__t('Choose-your-perfect-domain-name-We-offer-more-thaa9564f')}
			price={sitePrice.priceNew}
			currency={sitePrice.currency}
			priceAdditional={sitePrice.priceNewEUR}
			currencyAdditional={sitePrice.currencyEUR}
			link="/web-hosting-register-domains.php"
			isYearly={true}
			img={domainsIMG}/>}
		  {lang === 'bg' && <ServiceBox
			title={__t("WordPress Hosting")}
			description={__t('хостинг-оптимизиран-за-WordPress-сайт-всички-пред7aa7fe')}
			price={ssPrice.monthlyPriceNew}
			currency={ssPrice.currency}
			priceAdditional={ssPrice.monthlyPriceNewEUR}
			currencyAdditional={ssPrice.currencyEUR}
			link="/wp-hosting.php"
			img={wpHostingIMG}/>}
		  {lang === 'en' && <ServiceBox
			title={__t("SSL sертификат")}
			description={__t('сигурна-защита-за-всички-уеб-проекти-при-които-се949ed5')}
			price={certPrice.priceNew}
			currency={certPrice.currency}
			priceAdditional={certPrice.priceNewEUR}
			currencyAdditional={certPrice.currencyEUR}
			link="/web-hosting-page-certificates.php"
			isYearly={true}
			img={certIMG}/>}
		  {lang === 'bg' && <ServiceBox
			title={__t("Managed WordPress хостинг + AI")}
			description={__t('към-хостинг-услугата-получаваш-включен-сайт-асист56341a')}
			price={wpaiPrice.monthlyPriceNew}
			currency={wpaiPrice.currency}
			priceAdditional={wpaiPrice.monthlyPriceNewEUR}
			currencyAdditional={wpaiPrice.currencyEUR}
			link="/managed-wp-hosting.php"
			img={wpAIIMG}/>}
		  {lang === 'en' && <ServiceBox
			title={__t("WordPress Hosting")}
			description={__t('Everything-for-your-WordPress-website-in-one-plac9732bb')}
			price={ssPrice.monthlyPriceNew}
			currency={ssPrice.currency}
			priceAdditional={ssPrice.monthlyPriceNewEUR}
			currencyAdditional={ssPrice.currencyEUR}
			link="/wp-hosting.php"
			img={wpHostingIMG}/>}
		  {lang === 'bg' && <ServiceBox
			title={__t("Сайт билдър<br/>(с включен хостинг)", null, true)}
			description={__t('уебсайт-с-включен-хостинг-само-за-няколко-часа-и-d1afb7')}
			price={builderPrice.monthlyPriceNew}
			currency={builderPrice.currency}
			priceAdditional={builderPrice.monthlyPriceNewEUR}
			currencyAdditional={builderPrice.currencyEUR}
			link="/site-builder.php"
			img={builderIMG}/>}
		  {lang === 'en' && <ServiceBox
			title={__t("Управляем виртуален сървър (Managed VPS)")}
			description={__t('бърз-сигурен-и-надежден-сървър-с-контролен-панел-4bc43a')}
			price={mvpsPrice.monthlyPriceNew}
			currency={mvpsPrice.currency}
			priceAdditional={mvpsPrice.monthlyPriceNewEUR}
			currencyAdditional={mvpsPrice.currencyEUR}
			link="/web-hosting-common-managed-vps.php"
			img={mvpsIMG}/>}
		  {lang === 'bg' && <ServiceBox
			title={__t("Онлайн магазин<br/>(с включен хостинг)", null, true)}
			description={__t('бърз-и-лесен-старт-на-онлайн-магазин-без-инвестицf1cb35')}
			price={parseFloat(parseFloat(shopPrice.monthlyPriceNew) + parseFloat(shopPriceSupport.monthlyPriceNew)).toFixed(2)}
			currency={shopPrice.currency}
			priceAdditional={parseFloat(parseFloat(shopPrice.monthlyPriceNewEUR) + parseFloat(shopPriceSupport.monthlyPriceNewEUR)).toFixed(2)}
			currencyAdditional={shopPrice.currencyEUR}
			link="/web-hosting-compare-shop-plans.php"
			img={shopIMG}/>}
		  {lang === 'en' && <ServiceBox
			title={__t("Виртуален сървър (VPS)")}
			description={__t('хостинг-чрез-отделен-и-независим-сървър-при-гаран516a43')}
			price={vpsPrice.monthlyPriceNew}
			currency={vpsPrice.currency}
			priceAdditional={vpsPrice.monthlyPriceNewEUR}
			currencyAdditional={vpsPrice.currencyEUR}
			link="/web-hosting-page-servers-vps.php"
			img={vpsIMG}/>}
		  {lang === 'bg' && <ServiceBox
			title={__t("TLS/SSL сертификат")}
			description={__t('сигурна-защита-за-всички-уеб-проекти-при-които-сеa087bc')}
			price={certPrice.priceNew}
			currency={certPrice.currency}
			priceAdditional={certPrice.priceNewEUR}
			currencyAdditional={certPrice.currencyEUR}
			link="/web-hosting-page-certificates.php"
			isYearly={true}
			img={certIMG}/>}
	  </section>

	)
};
export default ComponentHomePageMainServices;